<template>
  <CRenderFunction flat :contentToRender="menu"/>
</template>

<script>
import Nav from "./_nav";

export default {
  created() {
    let children = [];
    for (let i = 0; i < Nav.length; i++) {
      let element = Nav[i];
      element['name'] = this.$t(element['name']);
      if(element['_name'] == "CSidebarNavDropdown"){
          for (let i = 0; i < element['items'].length; i++) {
              const item = element['items'][i];
              element['items'][i]['name'] = this.$t(item['name']);
          }
      }
      children.push(element);
    }

    this.menu[0]._children = children
  },

  data: () => ({
    menu: [
      {
        _name: 'CSidebarNav',
        _children: []
      }
    ]
  })
}
</script>
